import logomarkSrc from "@/assets/lel-logomark.png";
const logomark = { url: logomarkSrc };

export interface Step {
  title: string;
  body: string;
}

const POPPINS = { fontFamily: "'Poppins', sans-serif" } as const;

export function StepsList({ items, onDark = false }: { items: readonly Step[]; onDark?: boolean }) {
  return (
    <ol className="grid gap-5 md:grid-cols-2 md:gap-6">
      {items.map((item, i) => (
        <li
          key={item.title}
          className={`group relative overflow-hidden rounded-2xl border p-6 transition-all hover:-translate-y-1 md:p-7 ${
            onDark
              ? "border-white/15 bg-white/10 backdrop-blur-sm hover:border-white/30 hover:bg-white/15"
              : "border-border/60 bg-background hover:border-primary/30 hover:shadow-brand"
          }`}
        >
          <div className="flex items-start gap-4">
            <span className="flex shrink-0 items-center gap-2">
              <img
                src={logomark.url}
                alt=""
                aria-hidden="true"
                className={`h-8 w-8 object-contain md:h-9 md:w-9 ${onDark ? "brightness-0 invert" : ""}`}
              />
              <span
                className={`text-2xl font-black leading-none tabular-nums md:text-3xl ${
                  onDark ? "text-white" : "text-[#693D94]"
                }`}
                style={POPPINS}
              >
                {i + 1}
              </span>
            </span>
            <div className="min-w-0 pt-1">
              <h3
                className={`text-lg font-bold leading-snug md:text-xl ${
                  onDark ? "text-white" : "text-[#111111]"
                }`}
                style={POPPINS}
              >
                {item.title}
              </h3>
              <p
                className={`mt-2 text-sm leading-relaxed md:text-base ${
                  onDark ? "text-white/75" : "text-muted-foreground"
                }`}
              >
                {item.body}
              </p>
            </div>
          </div>
        </li>
      ))}
    </ol>
  );
}
